import { ScopedCssBaseline, ThemeProvider } from '@mui/material';
import { darkTheme } from 'modules/themes/darkTheme';
import { PropsWithChildren } from 'react';

/**
 * Since the top half of the layout is dark, we need to wrap some components in a dark theme provider so they can be rendered correctly.
 *
 * Usage:
 * ```tsx
 * <DarkModeSection>
 *  <PageTitle />
 * </DarkModeSection>
 * <RestOfComponent>
 * ```
 */
export function DarkModeSection({
  children,
  fullWidth,
}: PropsWithChildren & {
  fullWidth?: boolean;
}) {
  return (
    <ThemeProvider theme={darkTheme}>
      <ScopedCssBaseline
        sx={{
          width: fullWidth ? '100%' : undefined,
        }}
      >
        {children}
      </ScopedCssBaseline>
    </ThemeProvider>
  );
}
